/* eslint-disable react/prop-types */
/*
 * Copyright (c) 2025. Tooling Team
 */

import Layout from "../components/layout/Layout";
import { RouteDisplay } from "../components/navigation/RouteDisplay";
import { PATHS } from "../utils/constants";
import ModernBuildTable from "../components/ModernBuildTable";
import useMedDomain from "../hooks/useMedDomain";

export function MedDomainLatestBuilds() {
  return (
    <Layout>
      <div className="grid">
        <RouteDisplay pageRouteDisplay={[PATHS.medDomain]} />
        <div className="row mb-4">
          <ModernBuildTable
            useDataHook={useMedDomain}
            title="Med Domain Builds - Latest builds"
            routeDisplay={[PATHS.medDomain]}
            detailsPath={PATHS.medDomainDetails.url}
          />
        </div>
      </div>
    </Layout>
  );
}
